import React from "react";
import type { DailyMenu } from "../../types/DailyMenu";
import styles from "./MenuDetails.module.css";

interface Props {
  editing: boolean;
  isFutureLunch: boolean;
  menu: DailyMenu;
  tempMenu?: DailyMenu | null;
  onChange: (field: keyof DailyMenu, value: string | number) => void;
}

const MenuDetails: React.FC<Props> = ({
  editing,
  menu,
  tempMenu,
  onChange,
  isFutureLunch,
}) => {
  if (editing) {
    return (
      <div className={styles["menu-details"]}>
        <div className={styles["menu-details-edit"]}>
          <div>
            <label className={styles.label}>
              {isFutureLunch ? "Antall som lages til" : "Antall som spiste"}
            </label>
            <input
              type="number"
              value={tempMenu?.peopleAte ?? 0}
              min={0}
              onWheel={(e) => e.currentTarget.blur()}
              onChange={(e) =>
                onChange("peopleAte", Math.max(0, Number(e.target.value)))
              }
              className={styles.input}
            />

          </div>

          <div>
            <label className={styles.label}>Porsjoner igjen:</label>
            <input
              type="number"
              value={tempMenu?.portionsLeft ?? 0}
              min={0}
              onWheel={(e) => e.currentTarget.blur()}
              onChange={(e) =>
                onChange("portionsLeft", Math.max(0, Number(e.target.value)))
              }
              className={styles.input}
            />

          </div>

          <div>
            <label className={styles.label}>Notater:</label>
            <textarea
              value={tempMenu?.notes ?? ""}
              onChange={(e) => onChange("notes", e.target.value)}
              className={styles.textarea}
              rows={3}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`${styles["menu-details"]} ${styles["menu-details-readonly"]}`}
    >
      <p>
        <strong>
          {isFutureLunch ? "Antall som lages til" : "Antall som spiste"}
        </strong>{" "}
        {menu.peopleAte}
      </p>
      <p>
        <strong>Porsjoner igjen:</strong> {menu.portionsLeft}
      </p>
      {menu.suggestedBy && (
        <p>
          <strong>Foreslått av:</strong> {menu.suggestedBy}
        </p>
      )}
      <p className={styles.notes}>{menu.notes}</p>
    </div>
  );
};

export default MenuDetails;
